import React, {useContext, useEffect, useState} from 'react';
import Select from "react-select";
import {GisContext} from "../context/gis-context.jsx";
import {useQuery} from "@tanstack/react-query";
import gisService from "../../../../services/web/gis-service.js";
import {Modal} from "../../../../components/modal/modal.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {toast} from "react-toastify";
import useHasPermission from "../../../../hooks/use-has-permission.js";
import {PermissionEnum} from "../../../../utils/enums/permission-enum.js";
import InputRadio from "../../../../components/input/input-radio.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import Button from "../../../../components/button/button.jsx";

const GisModalDispatch = () => {
    const {modal, setModal} = useContext(GisContext);
    const {show, attendances, event} = modal;

    const [natureSelected, setNatureSelected] = useState(undefined);
    const [attendance, setAttendance] = useState([]);
    const [hasCall, setHasCall] = useState(false);

    const allowViewCall = useHasPermission(PermissionEnum.ATTENDANCE_APP_ALLOW_VIEW_CALL);

    const {data: reasons} = useQuery({
        queryFn: () => gisService.reasons(),
        queryKey: ["reasons"]
    });

    useEffect(() => {
        let attendanceSelected = attendances[0];
        if (attendances.length > 1) {
            attendanceSelected = attendances.find(item => !item.details.dispatch_activity) ?? [];
        }

        setAttendance(attendanceSelected);
    }, [attendances]);

    useEffect(() => setNatureSelected(undefined), [show]);

    const dispatchGarrison = (validate = false) => {
        if (!attendance.title && !natureSelected) {
            toast.error("Selecione uma natureza!");
            return;
        }

        if (!validate && event.garrisonType === "dispatchActivity") {
            projectUtils.swalMessage(
                "warning",
                "Atenção",
                "O despacho atual será encerrado. <br />Deseja continuar?",
                "Sim",
                true,
                "Não",
                () => dispatchGarrison(true)
            );

            return;
        }

        let nature = attendance.title;
        if (!attendance.title && natureSelected) nature = natureSelected.label;

        const formData = new FormData();

        formData.append("nature", nature);
        formData.append("garrisonId", event.id.split("-")[1]);
        formData.append("attendanceId", attendance.id.split("-")[1]);
        if (attendance.details.hasCall) formData.append("allowViewCall", hasCall);

        if (event.details?.activity) formData.append("dispatchToCloseId", event.details?.dispatchId);

        closeModal();

        gisService.setDispatch(formData)
            .then(() => {
                const dispatchType = attendance.details.support ? "Despacho de apoio" : "Despacho";

                toast.success(`${dispatchType} gerado com sucesso`)
            })
            .catch(error => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.errorMessages ?? error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            });
    }

    const closeModal = () => {
        setModal({
            ...modal,
            show: false
        });
    }

    return (
        <>
            <Modal open={show} setOpen={closeModal} title={`Gerar despacho${attendance?.details?.support ? " de apoio?" : "?"}`} className={"w-6/12"}>
                <Modal.Body className="mb-2 max-h-[calc(100vh-220px)] overflow-auto space-y-4">
                    <section className={"space-y-2"}>
                        <h3>Guarnição</h3>
                        <p>{event.title}</p>
                    </section>

                    <section className={"space-y-2"}>
                        <h3>{attendances?.length > 1 ? "Atendimentos" : "Atendimento"}</h3>
                        {
                            attendances.length > 1 ?
                                attendances.map(item => {

                                    const protocol = item.details.protocol;
                                    const dispatchActivity = item.details.dispatch_activity;

                                    return (
                                        <InputRadio
                                            key={item.id}
                                            name="inlineRadio"
                                            id={item.id}
                                            value={item.id}
                                            disabled={dispatchActivity}
                                            checked={attendance && attendance.id === item.id}
                                            label={`${protocol}: ${item.title}`}
                                            onChange={() => setAttendance(item)}
                                        />
                                    )
                                })
                                : <>{attendance?.details?.protocol}: {attendance?.title}</>
                        }
                        {
                            (allowViewCall && !attendance?.details?.support && attendance?.details?.hasCall) &&
                            <InputCheckbox
                                id="hasCall"
                                label="Enviar áudio da gravação telefônica para o app Sentry Despacho"
                                className="mt-2"
                                checked={hasCall}
                                onChange={() => setHasCall(!hasCall)}
                            />
                        }

                        {
                            attendance && !attendance.title &&
                            <Select
                                defaultValue={natureSelected}
                                options={reasons ?? []}
                                placeholder={"Natureza *"}
                                isClearable={true}
                                onChange={(item) => setNatureSelected(item)}
                                noOptionsMessage={() => "Nenhuma natureza encontrado"}
                                className={"mt-2"}
                            />
                        }
                    </section>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => dispatchGarrison()} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GisModalDispatch;